module.exports = "<!-- <p>\n  landing-page works!\n</p> -->\n"